module.exports = {
        srcSet: __webpack_public_path__ + "a26edfb7aea5ee13-600.webp"+" 600w"+","+__webpack_public_path__ + "193a261bd90f7bd8-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "a26edfb7aea5ee13-600.webp",width: 600,height: 399},{path: __webpack_public_path__ + "193a261bd90f7bd8-1000.webp",width: 1000,height: 665}],
        src: __webpack_public_path__ + "193a261bd90f7bd8-1000.webp",
        toString: function(){return __webpack_public_path__ + "193a261bd90f7bd8-1000.webp"},
        
        width: 1000,
        height: 665
      }